export const SELECT_DEFAULT_OPTION = {
	label: 'All',
	value: null,
};
